import { render, staticRenderFns } from "./ActivityRegList.vue?vue&type=template&id=30ba63a5&scoped=true"
import script from "./ActivityRegList.vue?vue&type=script&lang=js"
export * from "./ActivityRegList.vue?vue&type=script&lang=js"
import style0 from "./ActivityRegList.vue?vue&type=style&index=0&id=30ba63a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ba63a5",
  null
  
)

export default component.exports